// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog__overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1100;
}

.dialog__box {
    background: var(--color-bg-2);
    border: 1px solid var(--color-border);
    border-radius: 7px;
    min-width: 352px;
    max-width: 528px;
    width: 100%;
    box-shadow: 0 9px 35px rgba(0, 0, 0, 0.4);
}

.dialog__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 18px 11px;
    border-bottom: 1px solid var(--color-border);
}

.dialog__title {
    font-size: 14px;
    font-weight: 600;
    color: var(--color-text);
}

.dialog__close {
    font-size: 13px;
    color: var(--color-text-muted);
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 3px;
    line-height: 1;
    transition: color 0.15s, background-color 0.15s;
}

@media (pointer: fine) {
    .dialog__close:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.dialog__body {
    padding: 18px;
    display: flex;
    flex-direction: column;
    gap: 11px;
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/Dialog/s.dialog.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb","sourcesContent":[".dialog__overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1100;\n}\n\n.dialog__box {\n    background: var(--color-bg-2);\n    border: 1px solid var(--color-border);\n    border-radius: 7px;\n    min-width: 352px;\n    max-width: 528px;\n    width: 100%;\n    box-shadow: 0 9px 35px rgba(0, 0, 0, 0.4);\n}\n\n.dialog__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 13px 18px 11px;\n    border-bottom: 1px solid var(--color-border);\n}\n\n.dialog__title {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--color-text);\n}\n\n.dialog__close {\n    font-size: 13px;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    padding: 2px 6px;\n    border-radius: 3px;\n    line-height: 1;\n    transition: color 0.15s, background-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .dialog__close:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.dialog__body {\n    padding: 18px;\n    display: flex;\n    flex-direction: column;\n    gap: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
